import { Button } from "primereact/button";
import { TourAnchor } from "training/anchors";

interface IBackToDetailsButtonProps {
  onClick: () => void;
}

/**
 * "Back to details" under checkout (Stripe PaymentSection and FinixPaymentSection): closes checkout and goes back
 * to the billing statement.
 *
 * `type="button"`: it sits inside checkout's `<form>` (ContainerForm, which has no submit handler), and a
 * <button> without a type is a submit button. A click then also submitted the form — a native GET to the page's
 * own URL with an empty query, which reloads the whole app. During Clear Certified training (CLE-3015, step
 * m4.09) the tour has already moved to the Estimate Details page by then, so the reload landed on
 * `/orders/<id>?` and wiped the tour's in-memory hand-off: no popover, and the trainee had to press Resume
 * (nightly walk, local runs on 2026-10-22).
 */
export function BackToDetailsButton({ onClick }: IBackToDetailsButtonProps) {
  return (
    <div className="flex align-items-center justify-content-center mt-3">
      <Button
        type="button"
        className="p-button-text mb-0 p-button-secondary p-0"
        onClick={onClick}
        data-tour={TourAnchor.BackToDetails}
      >
        <p className="text-sm purple font-semibold">Back to details</p>
      </Button>
    </div>
  );
}
